import React, { useState, useEffect } from "react"
import { Form, Button, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap"
import InputField from "./elements/input"
import SelectField from "./elements/select"
import TextAreaField from "./elements/textarea"
import ButtonField from "./elements/button"
import HtmlBox from "./elements/html"
import ReCaptchaBox from "./elements/recaptcha"
import { postFormData } from "./api/Api"
import axios from "axios"
import * as qs from "query-string"
import $ from "jquery/dist/jquery.min.js"
import { getUser } from "@starberry/myaccount-website-utils"

function MaintenanceForm(props) {
  const userData = getUser()

  const [validated, setValidated] = useState(false)
  const [showerror, setShowerror] = useState(false)
  const [showthankyou, setThankyou] = useState(false)
  const [formvalues, setFormvalues] = useState("")
  const [token, setToken] = useState("")
  const [selectedFiles, setSelectedFiles] = useState([])
  const [fileError, setFileError] = useState("")

  const myRef = React.createRef()
  const recaptchaRef = React.createRef()

  const categories = [
    "Plumbing",
    "Electrical",
    "Heating",
    "Boiler",
    "Water Leak",
    "Damp & Mould",
    "Windows & Doors",
    "Appliances",
    "Garden / Exterior",
    "General Repair",
    "Other",
  ]

  const fields = [
    {
      element: "config",
      formname: "Maintenance Reporting Form",
      form_type: "maintenance_reporting",
      error_text: "Highlighted fields are required",
      success_text:
        "Thank you for reporting the issue. Our maintenance team will review it and get in touch with you shortly.",
      email_temp_user: "maintenance_user",
      email_temp_admin: "maintenance_admin",
      email_server_func: "maintenance",
      event_tracking: "maintenance_reporting",
      page_url: "/maintenance-reporting",
    },
  ]

  const handlechange = event => {
    event.target.value = event.target.value.trimStart()
  }

  const handleFileChange = event => {
    const files = Array.from(event.target.files)
    setFileError("")

    if (files.length === 0) {
      setFileError("At least one photo or video is required.")
      setSelectedFiles([])
      return
    }

    if (files.length > 5) {
      setFileError("You can upload a maximum of 5 files.")
      setSelectedFiles([])
      event.target.value = ""
      return
    }

    // File validation
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "video/mp4",
      "video/quicktime",
      "video/ogg",
      "video/webm"
    ]
    const maxSize = 15 * 1024 * 1024 // 15MB per file

    for (let file of files) {
      if (!allowedTypes.includes(file.type)) {
        setFileError("Only JPG, JPEG, PNG images and MP4, MOV, OGG, WEBM videos are allowed.")
        setSelectedFiles([])
        event.target.value = ""
        return
      }
      if (file.size > maxSize) {
        setFileError("Each file must be less than 15MB.")
        setSelectedFiles([])
        event.target.value = ""
        return
      }
    }

    setSelectedFiles(files)
  }

  useEffect(() => {
    if (token !== "") {
      const processFromData = async () => {
        let formData = new FormData()

        // Append multiple files to files.attachment (Strapi standard)
        if (selectedFiles.length > 0) {
          selectedFiles.forEach(file => {
            formData.append("files.attachment", file, file.name)
          })
        }

        formData.append("data", JSON.stringify(formvalues))

        postFormData(formData)
          .then(apiRes => {
            let uploadedUrls = []

            if (apiRes?.attachment && apiRes.attachment.length > 0) {
              uploadedUrls = apiRes.attachment.map(att => {
                return att.url.match(/(http|https):\/\//g)
                  ? att.url
                  : `${process.env.GATSBY_STRAPI_FORM_URL}${att.url}`
              })
            }

            if (uploadedUrls.length > 0) {
              formvalues["photos"] = uploadedUrls.join(",")
            } else {
              formvalues["photos"] = "N/A"
            }

            // Send mail
            const axiosOptions_email = {
              url: "/.netlify/functions/server/" + fields[0].email_server_func,
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: qs.stringify(formvalues),
            }

            axios(axiosOptions_email)
              .then(response => {
                console.log("Email sent successfully")
                setSelectedFiles([])
              })
              .catch(err => {
                console.error("Error sending email", err)
              })
          })
          .catch(err => {
            console.error("API error", err)
          })

        // Event tracking
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: "formSubmit",
          formType: "form-maintenance-reporting",
          formId: "form-maintenance-reporting",
          formName: "Maintenance Reporting Form",
          formLabel: "Maintenance Reporting Form",
        })

        setShowerror(false)
        setThankyou(true)
        if (myRef.current) {
          myRef.current.scrollIntoView({ behavior: "smooth" })
        }
      }
      processFromData()
    }
  }, [token])

  const handleonVerify = token => {
    setToken(token)
  }

  const handleSubmit = event => {
    const form = event.currentTarget
    let currentFileError = ""

    // Validate photo upload on submit
    if (selectedFiles.length === 0) {
      currentFileError = "At least one photo or video is required."
    } else if (selectedFiles.length > 5) {
      currentFileError = "You can upload a maximum of 5 files."
    } else {
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "video/mp4",
        "video/quicktime",
        "video/ogg",
        "video/webm"
      ]
      const maxSize = 15 * 1024 * 1024 // 15MB per file
      for (let file of selectedFiles) {
        if (!allowedTypes.includes(file.type)) {
          currentFileError = "Only JPG, JPEG, PNG images and MP4, MOV, OGG, WEBM videos are allowed."
          break
        }
        if (file.size > maxSize) {
          currentFileError = "Each file must be less than 15MB."
          break
        }
      }
    }

    if (currentFileError) {
      setFileError(currentFileError)
      event.preventDefault()
      event.stopPropagation()
      setShowerror(true)
      setValidated(true)
      setThankyou(false)
      if (myRef.current) {
        myRef.current.scrollIntoView({ behavior: "smooth" })
      }
      return
    }

    if (form.checkValidity() === false) {
      event.preventDefault()
      event.stopPropagation()
      setShowerror(true)
      setValidated(true)
      setThankyou(false)
      if (myRef.current) {
        myRef.current.scrollIntoView({ behavior: "smooth" })
      }
    } else {
      event.preventDefault()
      const formsdata = event.target
      const json = {}

      Object.keys(formsdata).forEach(key => {
        if (formsdata[key].name) {
          json[formsdata[key].name] = formsdata[key].checked
            ? "yes"
            : formsdata[key].value
        }
      })

      json["email_temp_user"] = fields[0].email_temp_user
      json["email_temp_admin"] = fields[0].email_temp_admin
      json["formname"] = fields[0].formname
      json["g-recaptcha-response"] = token

      setFormvalues(json)
      recaptchaRef.current.execute()
      setValidated(false)
      event.target.reset()
    }
  }

  return (
    <div className="form stbform fix-right">
      <div ref={myRef} id="scroll_view" />
      {showerror && (
        <div className="alert-error">
          <p>{fields[0].error_text}</p>
        </div>
      )}

      {showthankyou && (
        <div className="alert-success">
          <p>{fields[0].success_text}</p>
        </div>
      )}

      <Form
        className="tab-form career-fr"
        name={fields[0].formname}
        method="post"
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        encType="multipart/form-data"
      >
        <input type="hidden" name="form_name" value={fields[0].formname} />
        <input type="hidden" name="form_type" value={fields[0].form_type} />
        <input type="hidden" name="to_email_id" value={props.to_email_id} />
        <input type="hidden" name="bot-field" />

        <Row>
          <Col md={12}>
            <InputField
              name="name"
              grpmd="12"
              type="text"
              placeholder="Full Name*"
              required={true}
              patternchk="^[a-zA-Z0-9()]+(\s+[a-zA-Z0-9()]+)*$"
              handlechange={handlechange}
              defaultValue={userData?.name || ""}
              maxLength={100}
            />
          </Col>

          <Col md={12}>
            <InputField
              name="telephone"
              grpmd="12"
              type="text"
              placeholder="Contact Number*"
              required={true}
              handlechange={handlechange}
              defaultValue={userData?.telephone || ""}
            />
          </Col>

          <Col md={12}>
            <InputField
              name="email"
              grpmd="12"
              type="email"
              placeholder="Email Address*"
              required={true}
              patternchk="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
              handlechange={handlechange}
              defaultValue={userData?.email || ""}
            />
          </Col>

          <Col md={12}>
            <InputField
              name="address"
              grpmd="12"
              type="text"
              placeholder="Property Address*"
              required={true}
              handlechange={handlechange}
            />
          </Col>

          <Col md={12}>
            <Form.Group controlId="validationmessage">
              <div className="custom-float">
                <Form.Control
                  className="form-control"
                  name="message"
                  required={true}
                  as="textarea"
                  rows="4"
                  onChange={handlechange}
                  placeholder=" "
                />
                <label className="plclabel font-weight-bold" style={{ display: 'inline-flex', alignItems: 'center', pointerEvents: 'auto' }}>
                  Description of the Maintenance Issue*
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="description-tooltip">
                        If the issue related to an appliance, please include appliance model information. Please provide as much detail as possible, including when the issue started, where the issue is located within the property, and any actions already taken.
                      </Tooltip>
                    }
                  >
                    <span 
                      style={{ 
                        display: "inline-block", 
                        width: "21px", 
                        height: "20px", 
                        marginLeft: "6px", 
                        backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='20' fill='none' viewBox='0 0 21 20'%3E%3Cpath stroke='%234C505B' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.3' d='M10.195 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z'/%3E%3Cpath stroke='%234C505B' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.3' d='M9.57 9.375h.625v4.375h.625'/%3E%3Cpath fill='%234C505B' d='M10.195 7.344a.781.781 0 1 0 0-1.563.781.781 0 0 0 0 1.563Z'/%3E%3C/svg%3E")`,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        cursor: "pointer"
                      }} 
                    />
                  </OverlayTrigger>
                </label>
              </div>
            </Form.Group>
          </Col>

          <Col md={12} className="mb-4 mt-3">
            <Form.Group controlId="photoUpload">
              <div className="custom-float" style={{ paddingTop: "20px" }}>
                <div className="form-control-browsefile custom custom-file form-control attach-file-wrap">
                  <Form.Control
                    type="file"
                    multiple
                    accept="image/png, image/jpeg, image/jpg, video/mp4, video/quicktime, video/ogg, video/webm"
                    onChange={handleFileChange}
                    id="custom-file"
                  />
                  <label htmlFor="custom-file" className="custom-file-label">
                    {selectedFiles.length > 0
                      ? `${selectedFiles.length} file(s) selected`
                      : "Click to attach"}
                  </label>
                </div>
                <label 
                  className="plclabel font-weight-bold" 
                  style={{ 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    pointerEvents: 'auto',
                    top: "-24px",
                    color: "#4D4D4F"
                  }}
                >
                  Photo/Video Upload*
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="photo-tooltip">
                        Add photos or videos to help us assess the issue and determine the most appropriate course of action.
                      </Tooltip>
                    }
                  >
                    <span 
                      style={{ 
                        display: "inline-block", 
                        width: "21px", 
                        height: "20px", 
                        marginLeft: "6px", 
                        backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='20' fill='none' viewBox='0 0 21 20'%3E%3Cpath stroke='%234C505B' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.3' d='M10.195 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z'/%3E%3Cpath stroke='%234C505B' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.3' d='M9.57 9.375h.625v4.375h.625'/%3E%3Cpath fill='%234C505B' d='M10.195 7.344a.781.781 0 1 0 0-1.563.781.781 0 0 0 0 1.563Z'/%3E%3C/svg%3E")`,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        cursor: "pointer"
                      }} 
                    />
                  </OverlayTrigger>
                </label>
              </div>
              {selectedFiles.length > 0 && (
                <div
                  className="mt-2 text-muted"
                  style={{ fontSize: "14px", fontFamily: "ModernEra-Regular" }}
                >
                  Selected: {selectedFiles.map(f => f.name).join(", ")}
                </div>
              )}
              {fileError && (
                <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                  {fileError}
                </div>
              )}
            </Form.Group>
          </Col>

          <Col md={12}>
            <ButtonField
              name="Submit Report"
              type="submit"
              value="submit"
              class="primary"
              labelClass="content_b-18"
            />
          </Col>

          <Col md={12} className="mt-3">
            <HtmlBox
              text='By clicking Submit, you agree to our <a href="/terms-and-conditions/">Terms & Conditions</a> and <a href="/privacy-policy/">Privacy Policy</a>.'
              fieldClass="form-text terms modalterms"
            />
          </Col>

          <Col md={12}>
            <ReCaptchaBox
              fieldClass="py-2"
              captRef={recaptchaRef}
              handleonVerify={handleonVerify}
            />
          </Col>
        </Row>
      </Form>
    </div>
  )
}

const MaintenanceFormPage = props => (
  <MaintenanceForm to_email_id={props.to_email_id} />
)

export default MaintenanceFormPage
